<!--
 * @Author: zyf
 * @Date: 2025-04-18 11:41:51
 * @LastEditors: zyf
 * @LastEditTime: 2025-06-19 18:10:07
 * @Descripttion: 
-->
<template>
  <el-dialog :visible.sync="showFlag" width="auto" title="详情" class="custom-notice-message-detail-dialog" append-to-body :close-on-click-modal="false" @close="handleClose">
    <div class="notice-center-container">
      <MessageCard :noticeInfo="dataInfo" @jump="onJump" @download="onDownload" />
    </div>
  </el-dialog>
</template>
<script>
import {Dialog} from "element-ui";
import MessageCard from './MessageCard.vue';
import { downloadFileBlob } from '@/utils/tools';

export default {
  components: {
    "el-dialog": Dialog,
    MessageCard,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    noticeInfo:{
      type: Object,
      default: ()=>{
        return {};
      }
    }
  },
  data() {
    return {
      dataInfo:{},
      showFlag: false
    };
  },
  computed: {
  },
  watch: {
    show: {
      handler(val){
        this.showFlag = val;
      },
      deep:true,
      immediate: true
    }
  },
  methods:{
    handleClose(){
      this.$emit('close')
    },

    onJump(data){
      this.handleClose();
      if(data?.extra?.page_uuid){
        window.open(window.origin + '/page-editor?page_uuid=' + data?.extra?.page_uuid);
      }
    },

    async onDownload(data){
      if(data?.extra?.download_url){
        await downloadFileBlob(data?.extra?.download_url, data?.extra?.zip_name ? `${data?.extra?.zip_name}.zip` : '未命名文件.zip');
        this.$message.success('下载成功');
      }
    },
  },
  mounted() {
    this.dataInfo = this.noticeInfo;
  },
  created() {},
}
</script>
<style lang="less">
.custom-notice-message-detail-dialog{
  .el-dialog__body{
    padding: 0;
  }
  .el-dialog{
    border-radius: 12px;
  }
}
</style>
<style lang="less" scoped>
.notice-center-container{
  max-width: 912px;
  min-width: 540px;
  height: 100%;
  display: flex;
  overflow: hidden;
  max-height: 68vh;
  overflow-y: auto;
}
</style>
